export default "__VITE_ASSET__B1igBpV$__"